import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import TS from '../utils/TimeStampGenerator'
import {config} from "../utils/Constants";

const URL = config.url;

const initialState = {
    authorizationCode: "",
    qrData: "",
    status: "",
    qrTimeout: false,
    showQrWaitingImage: false,
    loading: "idle",
    opLoading: "idle",
    actionType: "",
    actionPayload: null,
    validationInfo: null,
    additionalData: null,
    error: null
};


export const generateAuthorizationCode = createAsyncThunk(
    "Authorization/GenerateAuthorizationQrCode",
    async (params = null) => {
        const token = sessionStorage.getItem("Token");
        const res = await axios.post(
            `${URL}/Authorization/GenerateAuthorizationQrCode`,
            {
                TypeID: params?.typeId,
                AdditionalInfo: JSON.stringify(params?.additionalData || {}),
            },
            {
                 headers: {
                    "Content-Type": "application/json",
                    "X-SESSION-ID": sessionStorage.getItem("SessionID"),
                    'Authorization': `Bearer ${token}`, 
                }
            }    
        );
        return res.data;
    }
);

export const checkAuthorizationStatus = createAsyncThunk(
    "Authorization/CheckAuthorizationQrCode",
    async (params) => {
        const token = sessionStorage.getItem("Token");
        const {authCode, controller} = params;
        if(authCode && authCode.length > 0) {
            try {
                const res = await axios.post(
                    `${URL}/Authorization/PortalActionsAuthorizationStatus`,
                    {        
                        TS: TS(),
                        authorizationCode: authCode,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-SESSION-ID": sessionStorage.getItem("SessionID"),
                            "Authorization": `Bearer ${token}`, 
                             
                        },
                        signal: controller.signal
                    }
                );
                const status = res.data.payload.status;
                return status;
            } catch (e) {
                throw e;
            }
        }
    }
);

export const getExpAuthCodeOnClose = createAsyncThunk(
    "Authorization/ExpireAuthorizationCodeOnClose",
    async (params) => {
        const token = sessionStorage.getItem("Token");
        const {authCode} = params;
        await axios.post(
            `${URL}/Authorization/ExpireAuthorizationCodeOnClose`,
            {
                TS: TS(),
                authorizationCode: authCode,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                    "X-SESSION-ID": sessionStorage.getItem("SessionID"),
                    "Authorization": `Bearer ${token}`
                }
            }
        );
    }
);


const authorizationCodeSlice = createSlice({
    name: "authorizationCode",
    initialState,
    reducers: {
        setAuthorizationCode: (state, action) => {
            state.authorizationCode = action.payload;
        },
        setQrData: (state, action) => {
            state.qrData = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setOpLoading: (state, action) => {
            state.opLoading = action.payload;
        },
        setAuthorizationCodeStatus: (state, action) => {
            state.status = action.payload;
        },
        setQrTimeout: (state, action) => {
            state.qrTimeout = action.payload;
        },
        setActionType: (state, action) => {
            state.actionType = action.payload;
        },
        setActionPayload: (state, action) => {
            state.actionPayload = action.payload;
        },
        setValidationInfo: (state, action) => {
            state.validationInfo = action.payload;
        },
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
        setShowQrWaitingImage: (state, action) => { 
            state.showQrWaitingImage = action.payload;
        },
        resetState: (state) => {
            state = {...initialState};
        }
    },
    extraReducers: (builder) => {
        builder.addCase(generateAuthorizationCode.pending, (state) => {
            if (state.loading === "idle") state.loading = "pending";
        });
        builder.addCase(
            generateAuthorizationCode.fulfilled,
            (state, action) => {
                if (state.loading === "pending") {
                    state.loading = "idle";
                    state.qrData = action.payload.payload.qrCode;
                    state.authorizationCode = action.payload.payload.authorizationCode;
                    state.qrTimeout = false;
                    state.error = null;
                }
            }
        );
        builder.addCase(generateAuthorizationCode.rejected, (state, action) => {
            if (state.loading === "pending") {
                state.qrData = "";
                state.authorizationCode = "";
                state.loading = "idle";
                state.error = action.error;
            }
        });
        builder.addCase(
            checkAuthorizationStatus.fulfilled,
            (state, action) => {
                state.status = action.payload;
                // state.qrTimeout = !(action.payload === "PENDING")
            }
        );
        builder.addCase(checkAuthorizationStatus.rejected, (state, action) => {
            state.qrData = "";
            state.authorizationCode = "";
            state.qrTimeout = true;
            state.error = action.error;
        });
    },
});

export const {    
    setActionType,
    setActionPayload,
    setAuthorizationCode,
    setQrTimeout,
    setQrData,
    setStatus,
    setOpLoading,
    setValidationInfo,
    setAdditionalData,
    setShowQrWaitingImage,
    resetState
} = authorizationCodeSlice.actions;

export default authorizationCodeSlice.reducer;
